import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';

// Components - Divertilandia App
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Packages from './pages/Packages';
import Calendar from './pages/Calendar';
import Inventory from './pages/Inventory';
import Events from './pages/Events';
import GameTypes from './pages/GameTypes';
import Expenses from './pages/Expenses';
import Vehicles from './pages/Vehicles';
import FuelPrices from './pages/FuelPrices';
import FuelExpenses from './pages/FuelExpenses';
import Reports from './pages/Reports';
import ContractGenerator from './pages/ContractGenerator';
import Settings from './pages/Settings';

// Components - WolvesLabs Landing Page
import LandingLayout from './components/landing/LandingLayout';
import Home from './pages/landing/Home';
import Login from './components/Login';

// Context
import { AuthProvider } from './contexts/AuthContext';

// Theme
import { divertilandiaTheme } from './theme';
import { wolvesLabsTheme } from './theme/wolvesLabsTheme';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* WolvesLabs Landing Page - Ruta raíz */}
          <Route
            path="/"
            element={
              <ThemeProvider theme={wolvesLabsTheme}>
                <CssBaseline />
                <LandingLayout>
                  <Home />
                </LandingLayout>
              </ThemeProvider>
            }
          />

          {/* Divertilandia Login - Sin protección */}
          <Route 
            path="/divertilandia/signin" 
            element={
              <ThemeProvider theme={divertilandiaTheme}>
                <CssBaseline />
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <Login />
                </LocalizationProvider>
              </ThemeProvider>
            } 
          />

          {/* Divertilandia App - Rutas protegidas */}
          <Route
            path="/divertilandia/*"
            element={
              <ThemeProvider theme={divertilandiaTheme}>
                <CssBaseline />
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="packages" element={<Packages />} />
                        <Route path="calendar" element={<Calendar />} />
                        <Route path="inventory" element={<Inventory />} />
                        <Route path="events" element={<Events />} />
                        <Route path="game-types" element={<GameTypes />} />
                        <Route path="expenses" element={<Expenses />} />
                        <Route path="vehicles" element={<Vehicles />} />
                        <Route path="fuel-prices" element={<FuelPrices />} />
                        <Route path="fuel-expenses" element={<FuelExpenses />} />
                        <Route path="reports" element={<Reports />} />
                        <Route path="contracts" element={<ContractGenerator />} />
                        <Route path="settings" element={<Settings />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                </LocalizationProvider>
              </ThemeProvider>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
